import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'


class DetailBloc {

    detailChannel = new Subject();
    BKNServiceIdentitasChannel = new Subject();
    BKNServiceJabatanChannel = new Subject();
    updateChannel = new Subject();
    rowtableChannel = new Subject();
    exportChannel = new Subject();
    sendToBKNChannel = new Subject();
    sendToSIMPEGChannel = new Subject();
    downloadFileChannel = new Subject();
    
    repository = new DetailRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.BKNServiceIdentitasChannel.next({status: apiResponse.INITIAL})
        this.BKNServiceJabatanChannel.next({status: apiResponse.INITIAL})
        this.updateChannel.next({status: apiResponse.INITIAL})
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.exportChannel.next({status: apiResponse.INITIAL})
        this.sendToBKNChannel.next({status: apiResponse.INITIAL})
        this.sendToSIMPEGChannel.next({status: apiResponse.INITIAL})
    }

    fetchListPresensi = async (query, cancelToken) => {
        this.rowtableChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchListPresensi(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    BKNServiceIdentitas = async (query) => {
        this.BKNServiceIdentitasChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.BKNServiceIdentitas(query).then((result) => {
                this.BKNServiceIdentitasChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.BKNServiceIdentitasChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    BKNServiceJabatan = async (query) => {
        this.BKNServiceJabatanChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.BKNServiceJabatan(query).then((result) => {
                this.BKNServiceJabatanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.BKNServiceJabatanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    fetchUpdatePresensi = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchUpdatePresensi(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    fetchExport = async (query) => {
        this.exportChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    sendToBKN = async (query) => {
        try {
            this.sendToBKNChannel.next({status: apiResponse.LOADING})
            await this.repository.sendToBKN(query).then((result) => {
                this.sendToBKNChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.sendToBKNChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    downloadFile = async (query) => {
        try {
            this.downloadFileChannel.next({status: apiResponse.LOADING})
            await this.repository.downloadFile(query).then((result) => {
                this.downloadFileChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadFileChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    sendToSIMPEG = async (query) => {
        try {
            this.sendToSIMPEGChannel.next({status: apiResponse.LOADING})
            await this.repository.sendToSIMPEG(query).then((result) => {
                this.sendToSIMPEGChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.sendToSIMPEGChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    
}

export default DetailBloc